import { _ } from "../../../../helpers/dom-selectors.js";
import makeForm from "../../../global-components/form.js";
import APP_EVENTS from "../init/events.js";
const ChangePassForm = makeForm({
    form: _('changePassForm'),
    submitBtn: _('resetPassBtn'),
    preventDefault: true,
    events: APP_EVENTS,
    action: 'change-pass-form-submitted',
});
export default ChangePassForm;
